import { PaymentURL } from "@adapters/infrastructures/urlConfig/PaymentFlow/paymentURL";
import { MFpayemnts } from "@adapters/features/TOCJourney/Repository/DummyReponse";
import { mfBankList } from "./DummyResponse";
class PaymentFlowRepository {
    constructor(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    async tradePayment(req) {
        const url = new URL(PaymentURL.tradePayment);
        // const pay = await this.http.makeApiCall<ITradePaymentMainParam>({
        //   method: "POST",
        //   url: url.toString(),
        //   body: req,
        // });
        return MFpayemnts.data;
        // return pay.data;
    }
    async paymentGateway(req) {
        const url = new URL(PaymentURL.paymentGateway + `/${await this.accountDetails.getUserID()}`);
        return await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
        });
    }
    async getPayBankDetails() {
        const url = new URL(PaymentURL.payBankDetails);
        // return await this.http.makeApiCall<IPayBankDetailsMainParams>({
        //   method: "GET",
        //   url: url.toString(),
        // });
        return mfBankList;
    }
    async getmfPaymentStatus(req) {
        const url = new URL(PaymentURL.orderStatus);
        url.searchParams.append("ordNo", req.ordNo);
        url.searchParams.append("txnDt", req.txnDt);
        url.searchParams.append("exOrdNo", req.exOrdNo);
        url.searchParams.append("pay", req.pay);
        const status = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return status.data;
    }
}
export default PaymentFlowRepository;
